import dayjs from "dayjs";
import { Link } from "react-router-dom";
// import PortalObject from "../../components/PortalObject/PortalObject";
import mapObjectValue from "../mapObjectValue";
import i18n from "../../i18n";
import Icon from "../../icons/Icon";
import { Badge, Popover } from "react-bootstrap";
// import PreviewModalOpener from "../../components/Modal/PreviewModal/PreviewModalOpener";
// import DetailPageLoader from "../../pages/DetailPage/DetailPageLoader";
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const operateFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    return <a className="details options-menu" href="javascript:void(0)" title="See Details">,
        <i className="bi bi-three-dots-vertical"></i>,
      </a>  
}

export const colorFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    return <div className="d-flex badge  w-100 h-100" style={{ minHeight: '20px', backgroundColor: value}} >
    </div> 
}

export const fieldFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value){
        const fields = kwargs.fields || ['name']
        var return_value =[]
        fields.forEach(field => { if(value[field]){ return_value.push(value[field]) }})
        return return_value.join(' - ')
    }
}

export const durationFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(!value){
        return '-'
    }
    var [days, time] = value.split(' ')
    if(!time){
        time = days
        days = null
    }
    const [hours, minutes, seconds] = time.split(':').map(unit => unit.startsWith('0') ? unit.startsWith('00') ? null : unit.substring(1) : unit)
    
    return <div className="duration d-flex flex-row align-items-center gap-1">
        {days && <div className="duration-days">{days} {i18n.t('Days')}</div>}
        {hours && <div className="duration-hours">{hours} {i18n.t('Hours')}</div>}
        {minutes && <div className="duration-minutes">{minutes} {i18n.t('Minutes')}</div>}
        {/* {seconds && <div className="duration-seconds">{seconds} {i18n.t('Seconds')}</div>} */}
    </div>
}


// export const previewFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
//     const app = kwargs.app
//     const className = kwargs.className || 'preview-opener'
//     return <PreviewModalOpener className={className} component={DetailPageLoader} componentProps={{app: app, id:value?.id || id}} > 
//         <div className="inline-flex align-items-center">{value} <Icon name="ICON_OPEN" /></div>
//     </PreviewModalOpener>
// }

export const arrayFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const many = kwargs.many || true
    const field = kwargs.field || 'name'
    if(value){  
        return value.length
    }
}
  
export const paymentFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value < 0 || value > -0){
        return  <span className="badge rounded-pill d-flex flex-row align-items-center bg-danger">€{value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}
            <span className="ms-1">
                {i18n.t('To be paid')}</span>
            </span>
    }else{
        return  <span className="badge rounded-pill d-flex flex-row align-items-center bg-success"> 
                <Icon name="ICON_CHECK" />
                <span className="ms-1">
                    {i18n.t('Fully paid')}
                </span>
            </span>
    }
}

export const locationsFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const locations = value.map( (option) => { 
        if(option.name){
            const delete_url = '/rest/location/'+option.id+'/'
            return <div className="badge bg-secondary text-start ms-1" >
                <span className="me-1">{option.name}</span>
                <Link to={`/location/${option.id}/edit/`} className="ms-auto"><i className="bi bi-pencil-square text-white"></i></Link>
                {/* <DeleteButton link_classes="ms-1" url={delete_url} />        */}
            </div>
        }
        return ""
    })
    return locations
}

export const imageFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value != null){
        return <img alt="table" className="table-image" src={value} />
    }
}

export const imageObjectFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value != null){
        return <img alt="table" className="table-image" src={value.image_webp} />
    }
}


export const textFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value != null){
        return  value
    }
}

export const euroFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value !== null && value !== undefined){
        return  "€" + value.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
    }
}

export const euroBadgeFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const className = kwargs.className || 'bg-secondary mt-1'
    if(value != null){
        return  <Badge className={className}  > {euroFormatter(value)} </Badge>
    }
}

export const percentageFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value != null){
        return  value + "%" 
    }
}

export const linkFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    let url = kwargs.url || ''
    url = url.replace('<pk>', id)
    if(value != null){
        return  <Link to={url}> {value}</Link>
    }
}


export const hrefFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value != null){
        return  <a href={value} target="_blank"> <i className="bi bi-download"></i></a>
    }
}

export const fileFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value != null){
        return  <a href={value} download> <i className="bi bi-download"></i></a>
    }
}

export const navigateFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const url = kwargs.url || ''
    const formatter = kwargs.formatter
    if(formatter){
        return <Link to={url} className="text-dark" >{formatter(value)}</Link>
    }
    return <Link to={url} className="text-dark" >{value}</Link>
}

export const detailFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const formatter = kwargs.formatter
    const app = kwargs.app
    const url = app ? `/${app}/${id}/` : id+"/"
    if(formatter){
        return <Link to={url} className="text-dark" >{formatter(value)}</Link>
    }
    return <Link to={url} className="text-dark" >{value}</Link>
}

export const dateFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const format = kwargs.format || 'DD-MM-YYYY'
    if(value != null){
        var date = Date.parse(value)
        var return_date = dayjs(date).format(format)
        if(return_date === 'Invalid Date'){
            return value
        }
        return return_date
    }
}

export const datetimeFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const format = kwargs.format || 'DD-MM-YYYY HH:mm'
    if(value != null){
        var date = Date.parse(value)
        var return_date = dayjs(date).format(format)
        if(return_date === 'Invalid Date'){
            return value
        }
        return return_date
    }
}

export const genericRelationFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const many = kwargs.many || true
    const field = kwargs.field || 'name'
    if(value){
        return value[field]
    }
}

export const multipleBadgeFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    const field = kwargs.field || 'name'
    if(value){
        const badges = value.map( (el) => 
            <span className="badge rounded-pill border border-secondary text-secondary mb-1">{el[field]}</span>
        )
        return <div className="d-flex flex-row flex-wrap gap-1">{badges}</div>
    }
}

export const keyValueFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    var total = null
    const showAllClick = (e) => {
        const totalValues = Object.keys(value).map((key) => {
            return <span key={key}>{key}: {mapObjectValue(null, value[key])}</span>
        })
        total === null ? total = totalValues : total = null
        return total
    }
    if(value){
        return <span typeof="button" onClick={showAllClick}  className="badge rounded-pill border border-secondary text-secondary mb-1">
                {Object.keys(value).length} {i18n.t('values')}
                {total} 
        </span>
    }   
}


// export const objectFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
//     const field = kwargs.field || 'name'
//     const url = kwargs.url || null 
//     const app = kwargs.app || null
//     // const success = kwargs.success || null
//     // const danger = kwargs.danger || null
//     // const warning = kwargs.warning || null
//     let badgeColor;
//     // if(success && row[success.field] === success.value){
//     //     badgeColor = 'success'
//     // }
//     // else if(danger && row[danger.field] === danger.value){
//     //     badgeColor = 'danger'
//     // }
//     // else if(warning && row[warning.field] === warning.value){
//     //     badgeColor = 'warning'
//     // }
//     // else{
//     //     badgeColor = 'secondary'	
//     // }
//     badgeColor = 'secondary'	

//     if(value){
//         const key = Object.keys(value)[1]
//         return <PortalObject key={`${id}_${value.id}_${key}`} object={value} field={field} url={url} app={app} id={value.id} >
//             <span className={`badge rounded-pill border border-${badgeColor} text-${badgeColor} mb-1`}>{value[key]}</span>
//         </PortalObject>
//     }   
// }


// export const multipleObjectFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
//     const field = kwargs.field || 'name'
//     const url = kwargs.url || null
//     const app = kwargs.app || null
//     if(value){
//         const badges = value.map( (el, index) => {
//             return objectFormatter(el, el, id, kwargs, objectActions)
//         })
//         return  <div key={`${id}_div`} className="d-flex flex-row flex-wrap gap-1" style={{'width':'200px', 'max-height':'125px', 'overflow':'auto'}}>{badges}</div>
//     }
// }


export const booleanFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value === true){
        return <i className="bi bi-check text-success" style={{'fontSize':'20px'}}></i>
    } 
    else if (value === false){
        return <i className="bi bi-x text-danger" style={{'fontSize':'20px'}}></i>
    }
    else{
        return '-'
    }   
}

export const translatedPercFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if( value !== "100%"){
      return <span className="badge rounded-pill bg-danger">{value}</span>
    }
    return <span className="badge rounded-pill border border-secondary text-secondary">{value}</span>
}



// const UserBadge = ({value, className, includeName = false}) => {
//     return (
//         <OverlayTrigger
//             placement="top"
//             rootClose={false}
//             trigger={['hover', 'focus']}
//             overlay={
//                 <Popover id={`tooltip-${value.id}`}>
//                     <Popover.Header>{value.full_name || (value.first_name + " " + value.last_name)}</Popover.Header>
//                     <Popover.Body>
//                         <div>Email: <a href={`mailto:${value.email}`}>{value.email}</a></div>
//                         {value.phone && <div>Call: <a href={`tel:${value.phone}`}>{value.phone}</a></div>}
//                     </Popover.Body>
//                 </Popover>
//             }
//         >
//             <div key={`${value.id}_div`} className="user-badge">
//                 {(value.image) ?   
//                     <img alt="user" src={value.image} className={className} />
//                     : (value.first_name) ? 
//                         <div alt="user" className={`bg-dark text-white ${className}`} > {value.first_name[0].toUpperCase()} </div>
//                         : <i className={`sidebar-icon ${value.icon}`}></i>
//                 }
//                 {includeName && <div className="sidebar-item-text ">{value.first_name}</div>}
//             </div>
//         </OverlayTrigger>
//     );
// }

// export const userBadgeFormatter = (value, row, id, kwargs = {}, objectActions = null) => {

//     const className = kwargs.className || "sidebar-icon profile-image d-flex justify-content-center align-items-center"
//     if(value){
//         return  <UserBadge value={value} className={className} {...kwargs} />
//     }
// }

// export const multipleUserBadgeFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
//     const className = kwargs.className || "sidebar-icon profile-image d-flex justify-content-center align-items-center"
//     if(value){
//         const badges = value.map( (el) => {
//             return <UserBadge key={`${id}_${el.id}`} value={el} className={className} />
//         })
//         return <div key={`${id}_div`} className="d-flex avatar-list avatar-list-stacked" > {badges}</div>
//     }
// }

export const userFormatter = (value, row, id, kwargs = {}, objectActions = null) => {
    if(value){
        return (
            <div className="user-badge">
                {(value.image) ?   
                    <img alt="user" src={value.image} className="sidebar-icon profile-image" />
                    : <i className={`sidebar-icon ${value.icon}`}></i>
                }
                <div className="sidebar-item-text ">
                    {value.first_name}
                </div>
            </div>
        )
    }
}